import React from 'react';
import Service from '../../components/service/Service';
import { featuredServices, servicePath } from '../../data/services.mjs';

import './services.css';

/**
 * Sección "Nuestros servicios" de la portada. Las tarjetas salen del catálogo
 * central (src/data/services.mjs) y enlazan a su página /servicios/<slug>,
 * lo que reparte autoridad interna hacia las páginas de servicio.
 */
const ICON_CLASSES = 'fables-second-text-color fa-3x';

const services = featuredServices('RD').map((s) => ({
    icon: `${s.icon} ${ICON_CLASSES}`,
    title: s.homeCard.title,
    description: s.homeCard.description,
    link: servicePath(s.slug),
}));

const Services = () => {
    return (
        <section className="container" id="services" aria-labelledby="services-title">
            <div className="row">
                <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 text-center" data-reveal="up">
                    <h2 id="services-title" className="fables-second-text-color font-35 font-weight-bold my-3 mt-md-5 mb-md-4">
                        <span className="title-underline">Nuestros servicios</span>
                    </h2>
                    <p className="fables-forth-text-color">
                        Facturación electrónica e-CF, software a la medida, sitios y aplicaciones web, apps móviles, eCommerce,
                        automatización con IA, marketing digital y equipos nearshore para empresas de República Dominicana y el extranjero.
                    </p>
                </div>
            </div>
            <div className="row my-3 my-md-5 overflow-hidden">
                {services.map((service, i) => {
                    return (
                        <Service
                            key={service.title}
                            index={i}
                            icon={service.icon}
                            title={service.title}
                            description={service.description}
                            link={service.link}
                        />
                    );
                })}
            </div>
        </section>
    )
};

export default Services;
